import StraigthenIcon from '@mui/icons-material/Straighten';
import React from 'react';

export const RulerIcon = props => (
  <StraigthenIcon style={{transform: 'rotate(-45deg)'}} {...props} />
);
